import React, { useState, useEffect } from 'react';
import { Navbar } from '..';
import './Header.css';

function Header() {
  const baseImagePath = process.env.REACT_APP_BASE_IMAGE_PATH;  
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <section className={scrolled ? "header header-scrolled" : "header"}>
      <section className="header-top">
        <section className="header-top__logo">
          <a href="/" className="header-logo">
            <img src={`${baseImagePath}logo/logo_bunt.png`} alt="Logo" />
          </a>
        </section>
        <section className="header-top__navbar">
          <Navbar />
        </section>
        <div className="hamburger-menu" onClick={toggleMenu}>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </section>

      <div className={menuOpen ? "mobile-menu active" : "mobile-menu"}>
        <span className="close-menu" onClick={toggleMenu}>&times;</span>
        <nav className="mobile-menu__navigation">
          <a href="/" onClick={toggleMenu}>Home</a>
          <a href="/travel" onClick={toggleMenu}>Reisen</a>
          <a href="/mountainguide" onClick={toggleMenu}>Bergführer</a>
          <a href="/avalanches" onClick={toggleMenu}>Schnee</a>
          <a href="/about" onClick={toggleMenu}>Über uns</a>
          <a href="/contact" onClick={toggleMenu}>Kontakt</a>
        </nav>
      </div>
    </section>
  );
}

export default Header;
